module.exports = __webpack_public_path__ + "img/aqua3.acf3384d.png";